<template>
    <div >
        <h6 class="font-weight-normal">{{ $t(`${configId}.upload.title`) }}</h6>
        <hr class="mt-2" />
        <div class="row">
            <div class="col-sm-4">
                <MaterialSelect
                    :disabled="disabled"
                    class="city-form-group city-bg"
                    id="input-status"
                    name="status"
                    label="name"
                    :filterable="true"
                    :options="lists.onoff"
                    v-model.trim="form.status"
                    :reduce="option => option.code"
                    :data-vv-scope="vScope"
                    v-validate="'required'"
                    :inputClasses="[{'is-invalid': fnHasError('status', vScope) }]"
                    :error=" fnFirstError('status', vScope)"
                    :helpText="helpUpload.status">
                    {{ $t(`${configId}.upload.model.status`) }}
                </MaterialSelect>
            </div>
            <div class="col-sm-4">
                <div class="form-group">
                    <MaterialInput
                        :readonly="disabled"
                        :disabled="disabled"
                        type="number"
                        class="city-form-group city-bg"
                        id="input-minfeatures"
                        name="minfeatures"
                        v-model.trim="form.minfeatures"
                        :data-vv-scope="vScope"
                        v-validate="{'required': true, 'integer': true, 'min_value': minFeatures}"
                        :inputClasses="[{'is-invalid': fnHasError('minfeatures', vScope) }]"
                        :error=" fnFirstError('minfeatures', vScope)"
                        :helpText="helpUpload.minfeatures">
                        {{ $t(`${configId}.upload.model.minfeatures`) }}
                    </MaterialInput>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="form-group">
                    <MaterialInput
                        :readonly="disabled"
                        :disabled="disabled"
                        type="number"
                        class="city-form-group city-bg"
                        id="input-maxfeatures"
                        name="maxfeatures"
                        v-model.trim="form.maxfeatures"
                        :data-vv-scope="vScope"
                        v-validate="{'required': true, 'integer': true, 'min_value': form.minfeatures}"
                        :inputClasses="[{'is-invalid': fnHasError('maxfeatures', vScope) }]"
                        :error=" fnFirstError('maxfeatures', vScope)"
                        :helpText="helpUpload.maxfeatures">
                        {{ $t(`${configId}.upload.model.maxfeatures`) }}
                    </MaterialInput>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-6">
                <div class="form-group">
                    <MaterialInput
                        :readonly="disabled"
                        :disabled="disabled"
                        type="text"
                        class="city-form-group city-bg"
                        id="input-filterProperty"
                        name="filterProperty"
                        v-model.trim="form.filterProperty"
                        :data-vv-scope="vScope"
                        v-validate="rulesUploadFilterName"
                        :inputClasses="[{'is-invalid': fnHasError('filterProperty', vScope) }]"
                        :error=" fnFirstError('filterProperty', vScope)"
                        :helpText="helpUpload.filterProperty">
                        {{ $t(`${configId}.upload.model.filterProperty`) }}
                    </MaterialInput>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <MaterialInput
                        :readonly="disabled"
                        :disabled="disabled"
                        type="text"
                        class="city-form-group city-bg"
                        id="input-filterBoundary"
                        name="filterBoundary"
                        v-model.trim="form.filterBoundary"
                        :data-vv-scope="vScope"
                        v-validate="rulesUploadFilterProperty"
                        :inputClasses="[{'is-invalid': fnHasError('filterBoundary', vScope) }]"
                        :error=" fnFirstError('filterBoundary', vScope)"
                        :helpText="helpUpload.filterGeneralBoundary">
                        {{ $t(`${configId}.upload.model.filterBoundary`) }}
                    </MaterialInput>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GlobalMixin from '@/app/shared/mixins/global';

export default {
    name: 'ConfigUploadGeneral',
    mixins: [
        GlobalMixin
    ],
    components: {

    },
    inject: {
        $validator: '$validator',   // This will make the component inherit it's parent's validator scope, thus sharing all errors and validation state.
    },
    props: {
        configId: {
            type: String,
            default: 'print_manage'
        },
        value: {
            type: Object,
            default: null
        },
        vScope: {
            type: String,
            default: 'form'
        },
        minFeatures: {
            type: Number,
            default: 0
        },
        disabled: {
            type: Boolean,
            default: false
        },
        uploadHelp: {
            type: Object,
        },
    },
    data() {
        return {
            lists: {
                loaded: false,
                onoff: [{'id': 1, 'name': 'Sim', 'code': 1}, {'id': 2, 'name': 'Não', 'code': 0}],
            },
            form: {
                status: null,
                minfeatures: 2,
                maxfeatures: 2,
                filterProperty: null,
                filterBoundary: null,
            },
        }
    },
    beforeMount () {
        this.copyValue(this.value)
    },
    mounted() {

    },
    computed: {
        helpUpload() {
            return this.uploadHelp ?? this.$t(`${this.configId}.upload.help`);
        },
        rulesUploadFilterName() {
            return {
                'required': false,//this.form.status == 1,
                'min': 3,
                'regex': /^([A-Za-z0-9, ]+)$/,
            };
        },
        rulesUploadFilterProperty() {
            return {
                'required': false,//this.form.status == 1,
                'min': 3,
                'regex': /^([A-Za-z0-9-_]+)$/,
            };
        },
    },
    methods: {
        copyValue (value) {
            Object.assign(this.form, value);
        },
    },
    watch: {
        value (newValue) {
            this.copyValue(newValue)
        },
        form: {
            handler(value, oldValue){
                this.$emit('input', value);
            },
            deep: true,
        },
    },
}
</script>

<style scoped lang="scss">

</style>
